'use client';

import { DataTestIdEnum } from '@medprev-web-app/datatestid';

import { CartItemField } from './cart-item-field.component';

const FLEX_SCHEDULING_NOTICE
  = 'Você deve entrar em contato com o profissional ou parceiro por Telefone/WhatsApp para agendar.';

export function CartItemFlexField() {
  return (
    <CartItemField
      label="Encaixe"
      value={<span>{FLEX_SCHEDULING_NOTICE}</span>}
      dataTestId={DataTestIdEnum.CART_ITEM_FIELD_FLEX}
    />
  );
}
